import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, EventEmitter, Input, Output, Directive, ElementRef, NgModule } from '@angular/core';
import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';

let UiCPdfGeneratorService = class UiCPdfGeneratorService {
    constructor() { }
    createPDF() {
        let doc = new jsPDF();
        return doc;
    }
};
UiCPdfGeneratorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCPdfGeneratorService_Factory() { return new UiCPdfGeneratorService(); }, token: UiCPdfGeneratorService, providedIn: "root" });
UiCPdfGeneratorService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UiCPdfGeneratorService);

let UiCPdfGeneratorComponent = class UiCPdfGeneratorComponent {
    constructor() { }
    ngOnInit() { }
};
UiCPdfGeneratorComponent = __decorate([
    Component({
        selector: 'ui-c-pdf-generator',
        template: "<p>\n  ui-c-pdf-generator works!\n</p>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCPdfGeneratorComponent);

let UiCPdfGeneratorDirective = class UiCPdfGeneratorDirective {
    constructor(el) {
        this.el = el;
        this.base64Emitter = new EventEmitter();
        this.self = this.el.nativeElement;
        this.self.addEventListener('click', () => this.toPdf());
    }
    set uiCPdfContent(element) {
        if (element !== null && element !== undefined) {
            this.content = element;
        }
    }
    /**
     * metodo principal para a geracao do pdf
     */
    toPdf() {
        this.loadService.show();
        domtoimage.toPng(this.content, { bgcolor: '#fff' }).then((image) => {
            const img = new Image();
            if (this.isMobile) {
                this.loadService.hide();
                this.base64Emitter.emit(image);
                return;
            }
            else {
                img.src = image;
                img.onload = () => {
                    const pdf = new jsPDF('p', 'px', [img.width, img.height]);
                    const width = pdf.internal.pageSize.getWidth();
                    const height = pdf.internal.pageSize.getHeight();
                    this.loadService.hide();
                    pdf.addImage(img, 'PNG', 5, 5, width, height);
                    pdf.save(`${new Date().getTime()}.pdf`);
                };
            }
        });
    }
};
__decorate([
    Input('uiCPdfContent'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], UiCPdfGeneratorDirective.prototype, "uiCPdfContent", null);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPdfGeneratorDirective.prototype, "base64Emitter", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCPdfGeneratorDirective.prototype, "loadService", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCPdfGeneratorDirective.prototype, "isMobile", void 0);
UiCPdfGeneratorDirective = __decorate([
    Directive({
        selector: '[uiCPdfGenerator]'
    }),
    __metadata("design:paramtypes", [ElementRef])
], UiCPdfGeneratorDirective);

let UiCPdfGeneratorModule = class UiCPdfGeneratorModule {
};
UiCPdfGeneratorModule = __decorate([
    NgModule({
        declarations: [
            UiCPdfGeneratorComponent,
            UiCPdfGeneratorDirective,
        ],
        exports: [
            UiCPdfGeneratorDirective,
        ],
        imports: []
    })
], UiCPdfGeneratorModule);

export { UiCPdfGeneratorComponent, UiCPdfGeneratorDirective, UiCPdfGeneratorModule, UiCPdfGeneratorService };
//# sourceMappingURL=wlp-ui-c-pdf-generator.js.map
